import { Component, OnInit, ViewChild } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Observable } from 'rxjs';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';
import { LoggerService } from '../../../../shared/sdk/services/custom';
import { ABaseComponent } from '../../../../shared/modules/ui/components/abstract/a-base.component';
import { AutoRepairShop, Employee, EmployeeView, Vehicle, VehicleService } from 'src/app/shared/sdk';
import { DataSourceOptions } from 'devextreme/data/data_source';
import { DataSourceService } from 'src/app/shared/modules/my-common/services/datasource.service';
import CustomStore from 'devextreme/data/custom_store';
import { VehicleServiceListComponent } from '../../components/vehicle-service-list/vehicle-service-list.component';

@Component({
  selector: 'app-vehicle-service',
  templateUrl: './vehicle-service.component.html',
  styleUrls: ['./vehicle-service.component.scss'],
})
export class VehicleServiceComponent extends ABaseComponent implements OnInit {
  $selectedArray$: BehaviorSubject<VehicleService[]> = new BehaviorSubject([]);
  selected$: Observable<VehicleService> = new Observable();

  $resize$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  @ViewChild(VehicleServiceListComponent, { static: true }) grid: VehicleServiceListComponent;

  autoRepairShopDso$: Observable<DataSourceOptions> = of([]);
  assignedFleetManagerDso$: Observable<DataSourceOptions> = of([]);

  extraFields = {
    noteCategory: 'Maintenance/Repair Note',
    serviceType: 'Maintenance',
    dateOffDuty: new Date(),
    dateReturnedOnDuty: new Date(),
    autoRepairShopId: null,
    assignedFleetManagerId: [],
  };

  constructor(
    protected logger: LoggerService,
    private dss: DataSourceService,
  ) {
    super(logger);

    this.selected$ = this.$selectedArray$.pipe(map(ids => (ids && ids.length ? ids[0] : null)));

    this.autoRepairShopDso$ = this.buildAutoRepairShopDsoDataSource();
    this.assignedFleetManagerDso$ = this.buildAssignedFleetManagerDataSource();
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  list_onSelected(vehicles: VehicleService[]) {
    if (vehicles && vehicles.length) {
      this.$selectedArray$.next(vehicles);
    } else {
      this.$selectedArray$.next([]);
    }
  }

  splitter_sizeChange(e) {
    this.$resize$.next(true);
  }

  autoRepairShop_displayExpr(e: AutoRepairShop) {
    return (e && `${e.name}`) || '';
  }

  assignedFleetManager_displayExpr(e: EmployeeView) {
    return (e && `${e.person_firstname} ${e.person_lastname}`) || '';
  }

  private buildAutoRepairShopDsoDataSource() {
    const so = this.dss.getStoreOptions(AutoRepairShop, undefined, false);
    const dso: DataSourceOptions = {
      store: new CustomStore(so),
    } as DataSourceOptions;
    return of(dso);
  }

  private buildAssignedFleetManagerDataSource() {
    const dso = this.dss.getDataSourceOptions(Employee);
    dso.filter = ['employeePosition_id', '=', 36];
    dso.sort = [{ selector: 'person_firstname' }, { selector: 'person_lastname' }];
    return of(dso);
  }
}
